export const UGC_TYPES = {
    campaignMedia: 'campaign-media',
    myMedia: 'me',
    trophy: 'trophy'
};
